import withReducer from '../../store/withReducer'
import Settings from './container'
import reducer from './module'

export default withReducer('settings', reducer)(Settings)



// WEBPACK FOOTER //
// ./src/legacy/pages/Settings/index.js